import * as ActionTypes from "constants/ActionTypes";
import { combineReducers } from "redux";

function dashJsLoadComplete(state = false, action) {
  switch (action.type) {
    case ActionTypes.DASH_JS_LOAD_COMPLETE:
      return true;
    default:
      return state;
  }
}

function initialLoadComplete(state = false, action) {
  switch (action.type) {
    case ActionTypes.INITIAL_LOAD_COMPLETE:
      return true;
    default:
      return state;
  }
}

function verseThreeLoadComplete(state = false, action) {
  switch (action.type) {
    case ActionTypes.VERSE_THREE_LOAD_COMPLETE:
      return true;
    default:
      return state;
  }
}

export default combineReducers({
  initialLoadComplete,
  dashJsLoadComplete,
  verseThreeLoadComplete,
});
